<template>
  <transition name="explain-fade">
    <div class="explain" v-show="state===1" @click="cancel" @touchmove.prevent>
      <div class="explain-wrappper" @click.stop>
        <slot ></slot>
      </div>
    </div>
  </transition>
</template>
<script>
  import BScroll from 'better-scroll'
  const STATE_HIDE = 0
  const STATE_SHOW = 1
  const COMPONENT_NAME = 'explain'
  export default {
    name: COMPONENT_NAME,
    props: {
      data: {
        type: Array,
        default () {
          return []
        }
      },
      title: {
        type: String
      },
      cancelTxt: {
        type: String,
      },
      confirmTxt: {
        type: String,
      },
      selectedIndex: {
        type: Array,
        default () {
          return []
        }
      },
      value: {
        type: Boolean,
        default: false
      },
      closeModal:{
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        state: STATE_HIDE,
      }
    },
    methods: {
      confirm() { },
      cancel() {
        if(!this.closeModal){
          this.hide()
        }
      },
      show() {
        this.state = STATE_SHOW
      },
      hide() {
        this.state = STATE_HIDE
      },
    },
  }

</script>

<style scoped>
  .explain {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 100;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: rgba(0, 0,0, .8);
    color: #fff;
  }


  .explain-fade-enter,
  .explain-fade-leave-active {
    opacity: 0
  }

  .explain-fade-enter-active,
  .explain-fade-leave-active {
    transition: all .3s ease-in-out;
  }
  

</style>



// WEBPACK FOOTER //
// explain.vue?90528cd8